<template>
    <div class="spo-card pa-2 rounded bordered">
        <div>Type d'inscription:
            <span class="font-weight-bold" v-if="dossard_bourse.associated_equipe_inscriptions.length > 0">Equipe</span>
            <span class="font-weight-bold" v-else>Solo</span>
        </div>
        <div>Parcours: <span class="font-weight-bold">{{ dossard_bourse.course.nom }}</span></div>
        <div>Options:</div>
        <div v-if="dossard_bourse.options.length == 0">Aucune option</div>

        <div v-else class="d-flex flex-wrap ga-1">
            <v-chip density="compact" v-for="option in dossard_bourse.options" :key="option.id">
                <v-icon size="small" :icon="get_icon(option.type)"></v-icon>
                {{ option.quantite }}x
                {{ option.nom }}
                <span v-if="option.size != ''">({{ option.size }})</span></v-chip>
        </div>

        <div v-if="dossard_bourse.associated_equipe_inscriptions.length > 0">
            <div>Ce dossard est associé à une équipe, voici les options associés au différents membres de l'équipe que
                vous allez aussi acheter:</div>

            <div v-for="equipe_inscription in dossard_bourse.associated_equipe_inscriptions"
                :key="equipe_inscription.id" class="d-flex flex-wrap ga-1">
                <v-chip density="compact" v-for="option in equipe_inscription.options" :key="option.id">
                    <v-icon size="small" :icon="get_icon(option.type)"></v-icon>
                    {{ option.quantite }}x
                    {{ option.nom }}
                    <span v-if="option.size != ''">({{ option.size }})</span></v-chip>
            </div>
        </div>
        <div class="mt-3">
            <SportipsButton icon="mdi-cart-plus" action-button @click="buyDossard">Acheter le dossard</SportipsButton>
        </div>



    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
export default {
    name: 'BourseDossardsItemListeAttente',
    props: {
        dossard_bourse: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapStores(useMainStore, useBookingStore),
    },
    methods: {
        async buyDossard() {
            this.mainStore.bookingSystem.booking.clearState();
            this.mainStore.bookingSystem.equipes.clearState();


            this.$router.push({ name: 'BuyDossardBourse', params: { id_dossard_bourse: this.dossard_bourse.id } });
        },
        get_icon(type) {
            switch (type) {
                case 'option':
                    return 'mdi-flash';
                case 'activite':
                    return 'mdi-nature-people';
                case 'article':
                    return 'mdi-shopping-outline';

                default:
                    return 'mdi-plus';
            }
        },
    }
}
</script>

<style lang="scss" scoped></style>